import React, { useEffect, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import { Button } from 'components/buttons/Button';

import { useLogout } from '../../components/logout/useLogout';

export const LogoutView = () => {
    const [loading, loggedOut, onLogout] = useLogout();
    const [logoutInitiated, setLogoutInitiated] = useState(false);

    useEffect(() => {
        if (loggedOut || loading || logoutInitiated) return;
        setLogoutInitiated(true);
        onLogout();
    }, [onLogout, loading, loggedOut, logoutInitiated]);

    if (loading) {
        return (
            <div className="tw-flex tw-justify-center tw-py-48">
                <div className="tw-animate-spin tw-h-24 tw-w-24 tw-border-2 tw-border-interactive tw-border-t-transparent tw-rounded-full" />
            </div>
        );
    }

    if (loggedOut) {
        return (
            <div>
                <h2 className="tw-text-l tw-font-semibold tw-mb-8">
                    <FormattedMessage
                        id="login.logout.title"
                        defaultMessage="You have been signed out"
                    />
                </h2>
                <p className="tw-text-neutral-subdued tw-text-s tw-mb-16">
                    <FormattedMessage
                        id="login.logout.description"
                        defaultMessage="You have been successfully signed out of SalesScreen."
                    />
                </p>
                <Link to="/">
                    <Button variant="primary" wrapperClasses="tw-w-full">
                        <FormattedMessage
                            id="login.logout.signInAgain"
                            defaultMessage="Sign in again"
                        />
                    </Button>
                </Link>
            </div>
        );
    }

    // initial or failed state
    return (
        <div>
            <h2 className="tw-text-l tw-font-semibold tw-mb-8">
                <FormattedMessage id="login.logout.confirm.title" defaultMessage="Sign out" />
            </h2>
            <p className="tw-text-neutral-subdued tw-text-s tw-mb-16">
                <FormattedMessage
                    id="login.logout.confirm.description"
                    defaultMessage="Are you sure you want to sign out?"
                />
            </p>
            <div className="tw-flex tw-flex-col tw-gap-8">
                <Button variant="primary" wrapperClasses="tw-w-full" onClick={onLogout}>
                    <FormattedMessage id="login.logout.confirm.signOut" defaultMessage="Sign out" />
                </Button>
                <a
                    href="/"
                    className="tw-text-primary tw-text-s tw-text-center tw-no-underline hover:tw-underline"
                >
                    <FormattedMessage
                        id="login.logout.confirm.returnToApp"
                        defaultMessage="Return to app"
                    />
                </a>
            </div>
        </div>
    );
};
